import React, { useEffect, useState } from 'react';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { auth, db } from '../firebase'; // Assuming you've initialized Firestore in a `firebase.js` module

const EmailPreference = () => {
  const [getEmails, setGetEmails] = useState(false);
  const user = auth.currentUser;

  useEffect(() => {
    if (!user) return;

    // Fetch the current preference from Firestore
    const fetchEmailPreference = async () => {
      const profileDocRef = doc(db, 'profiles', user.uid);
      const docSnap = await getDoc(profileDocRef);
      if (docSnap.exists()) {
        setGetEmails(docSnap.data().getEmails || false);
      } else {
        console.log('No such document!');
      }
    };

    fetchEmailPreference();
  }, [user]);

  const handleToggleEmailPreference = async () => {
    const newPreference = !getEmails;
    setGetEmails(newPreference);
  
    // Update the preference in Firestore
    const profileDocRef = doc(db, 'profiles', user.uid);
    try {
      await setDoc(profileDocRef, { getEmails: newPreference }, { merge: true });
      console.log('Preference updated successfully');
    } catch (error) {
      console.error('Error updating preference:', error);
    }
  };

  if (!user) {
    return <p>Loading...</p>;
  }

  return (
    <div>
      <label>
        Get Emails?
      </label>
      <input
          type="checkbox"
          checked={getEmails}
          onChange={handleToggleEmailPreference}
          className='ml-4 mt-4'
        />
    </div>
  );
};

export default EmailPreference;
